import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _window$__TELEMETRY_E;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import isElectron from 'is-electron';
import { isAuthServiceConfigured } from 'flow/authservice/authservice.config';
import { fromRuntime } from 'runtime-config';
var production = process.env.NODE_ENV === 'production';
var test = process.env.NODE_ENV === 'test'; // Jest sets the NODE_ENV to test
var version = "".concat(process.env.VERSION).concat(process.env.NO_UPDATE === 'true' ? '-NU' : '');
var beta = version.indexOf('beta') !== -1;
export var dev = !production && !beta;

// Electron: populate window.__RUNTIME_CONFIG__ from the .env file read by the main process.
// Must run before anything below reads from runtime config (e.g. isAuthServiceConfigured).
if (isElectron() && !test) {
  var _require;
  var ipcRenderer = (_require = require('electron')) === null || _require === void 0 ? void 0 : _require.ipcRenderer;
  var envObject = ipcRenderer === null || ipcRenderer === void 0 ? void 0 : ipcRenderer.sendSync('get-env');
  // The renderer's real environment wins over the packaged .env file,
  // matching dotenv's no-override semantics in the main process. In dev
  // (start-hot) there is no .env file and APP_FLOW_URL comes from the npm
  // script's environment instead.
  var env = _objectSpread(_objectSpread({}, (envObject === null || envObject === void 0 ? void 0 : envObject.parsed) || {}), process.env);
  window.__RUNTIME_CONFIG__ = {
    apiUrl: env.APP_FLOW_URL || 'https://flow.telavox.com',
    authServiceUrl: env.APP_AUTHSERVICE_URL || '',
    authServiceRealm: env.APP_AUTHSERVICE_REALM || 'telavox',
    authServiceClientId: env.APP_AUTHSERVICE_CLIENTID || 'web-client',
    regionGeonexService: env.REGION_GEONEX_SERVICE || '',
    regionLookupEnabled: env.REGION_LOOKUP_ENABLED === 'true',
    uaePassEnabled: env.UAE_PASS_ENABLED === 'true',
    faroCollectorUrl: env.FARO_COLLECTOR_URL || 'https://telemetry.telavox.com/collect',
    proxyUrl: dev ? env.PROXY_HOST || null : null
  };
}
var authServiceEnabled = isAuthServiceConfigured();
var environment = function (p, b) {
  if (p) {
    return b ? 'beta' : 'production';
  } else {
    return 'dev';
  }
}(production, beta);
export var apiUrl = fromRuntime('apiUrl');
export var proxyUrl = dev ? fromRuntime('proxyUrl') : null;
export var isGeonexConfigured = !!fromRuntime('regionGeonexService');
/**
 * AC-893 : Done this for the initial implementation since this enablement will be
 * only within telavox domain
 */
var aiStudioBaseUrl = "https://ai".concat(production ? '' : '-dev', ".telavox.com");
var topEnabled = function (p) {
  return p ? true : process.env.TOP_ENABLED === 'false' ? false : true;
}(production);
var localVideoSignaling = process.env.LOCAL_VIDEO_SIGNALING === 'true';
var localVideoChat = process.env.LOCAL_VIDEO_CHAT === 'true';
export var isUaePassEnabled = !!fromRuntime('uaePassEnabled');
export var faroCollectorUrl = fromRuntime('faroCollectorUrl');
// window.__TELEMETRY_ENV__ is expected to be absent in dev/Electron/pre-Slice-1
// images, so this must degrade to '' rather than throw like fromRuntime() does.
export var telemetryApiKey = ((_window$__TELEMETRY_E = window.__TELEMETRY_ENV__) === null || _window$__TELEMETRY_E === void 0 ? void 0 : _window$__TELEMETRY_E.apiKey) || '';
var appConfig = Object.freeze({
  production: production,
  version: version,
  beta: beta,
  dev: dev,
  environment: environment,
  apiUrl: apiUrl,
  topEnabled: topEnabled,
  localVideoSignaling: localVideoSignaling,
  localVideoChat: localVideoChat,
  authServiceEnabled: authServiceEnabled,
  isGeonexConfigured: isGeonexConfigured,
  isUaePassEnabled: isUaePassEnabled,
  faroCollectorUrl: faroCollectorUrl,
  telemetryApiKey: telemetryApiKey,
  aiStudioBaseUrl: aiStudioBaseUrl,
  proxyUrl: proxyUrl
});
if (!appConfig.production && !test) {
  console.group('Application config'); // eslint-disable-line no-console
  for (var o in appConfig) {
    console.log("".concat(o, " => ").concat(appConfig[o])); // eslint-disable-line no-console
  }
  console.groupEnd(); // eslint-disable-line no-console
}

/**
 * The application configuration - relies on window.__RUNTIME_CONFIG__ set by the
 * container entrypoint (web) or the Electron IPC handler (desktop).
 */
export default appConfig;